'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends8 = require('babel-runtime/helpers/extends');

var _extends9 = _interopRequireDefault(_extends8);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _translations = require('translations');

var _translations2 = _interopRequireDefault(_translations);

var _components = require('components');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _coreDecorators = require('core-decorators');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _Wizard = require('./Wizard.scss');

var _Wizard2 = _interopRequireDefault(_Wizard);

var _schedulerTasks = require('redux/modules/schedulerTasks');

var _themeEnabled = require('helpers/themeEnabled');

var _useBasename = require('../../helpers/useBasename');

var _useBasename2 = _interopRequireDefault(_useBasename);

var _status = require('redux/modules/status');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var md = {
  delete: require('react-icons/lib/md/delete')
};
var SCHEDULER_OFFSET = process.env.REACT_APP_SCHEDULER_OFFSET || 10;
var ScheduleWizard = (_dec = (0, _reactRedux.connect)(function (state) {
  return {};
}, {
  getSchedulerRecurrences: _schedulerTasks.getSchedulerRecurrences,
  getAccountStatus: _status.getAccountStatus
}), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  (0, _inherits3.default)(ScheduleWizard, _React$Component);

  function ScheduleWizard(props) {
    (0, _classCallCheck3.default)(this, ScheduleWizard);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ScheduleWizard.__proto__ || (0, _getPrototypeOf2.default)(ScheduleWizard)).call(this, props));

    _this.begin_update = function (state, rowInfo, column, instance) {
      var current_event = rowInfo ? rowInfo.original : null;
      var execution_date = (0, _moment2.default)(current_event.execution_date);
      var end_date = current_event.end_date ? (0, _moment2.default)(current_event.end_date) : (0, _moment2.default)();
      var recurrence = {
        value: current_event.recurrence.term,
        label: current_event.recurrence.label
      };
      _this.setState({
        selectedDate: execution_date.format("YYYY-MM-DD"),
        selectedHour: current_event.execution_hour,
        selectedMinute: current_event.execution_minute,
        execution_minute: current_event.execution_minute,
        execution_hour: current_event.execution_hour,
        hour: current_event.execution_hour,
        minute: current_event.execution_minute,
        recurrence: recurrence,
        recurrenceSelected: recurrence,
        startDate: current_event.start_date,
        finishDate: current_event.end_date ? 1 : 0,
        finishDay: end_date.date(),
        finishMonth: end_date.month(),
        finishYear: end_date.year(),
        is_update_event: true,
        update_event: current_event,
        selectedWeekDays: _this.getDays(current_event.recurrence.value),
        tabSelected: 2
      });
      // this.changeRecurrence(this.recurrence);
      // this.handleDateChange(execution_date);
    };

    _this.getDays = function (value) {
      if (value != undefined) {
        return _this.days.filter(function (day) {
          var filas = value.filter(function (value) {
            return day.value === value;
          });
          return filas.length > 0;
        });
      }
      return null;
    };

    _this.UUID = function () {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    };

    _this.colors = ['#0b82f1', '#EA994A', '#4FBDAA', '#0CF284', '#0CAEF2', '#0C85F2', '#5850F2', '#780CF2', '#C00DF3', '#F20696'];
    _this.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    _this.days = [{ label: (0, _translations2.default)('MONDAY'), value: 1 }, { label: (0, _translations2.default)('TUESDAY'), value: 2 }, { label: (0, _translations2.default)('WEDNESDAY'), value: 3 }, { label: (0, _translations2.default)('THURSDAY'), value: 4 }, { label: (0, _translations2.default)('FRIDAY'), value: 5 }, { label: (0, _translations2.default)('SATURDAY'), value: 6 }, { label: (0, _translations2.default)('SUNDAY'), value: 0 }];

    _this.selectedDates = _this.props.data.events.map(function (data) {
      return data.execution_date;
    });

    var tabSelected = 1;
    if (_this.props.data.events.length > 0) {
      tabSelected = 3;
    }

    var defaultDate = (0, _moment2.default)();
    _this.dates = {
      startDate: defaultDate.format('YYYY-MM-DD'),
      finishDate: defaultDate.format('YYYY-MM-DD'),
      hour: defaultDate.format('HH:mm')
    };

    _this.state = {
      finishDate: null,
      finishMonth: defaultDate.month(),
      finishDay: defaultDate.date(),
      finishYear: defaultDate.year(),
      selectedHour: null,
      selectedMinute: null,
      selectedDates: _this.selectedDates,
      selectedWeekDays: null,
      isMonthly: false,
      selectedDate: null,
      tabSelected: tabSelected,
      messageInFile: _this.props.data.messageInFile,
      dates: _this.dates,
      colors: _this.colors,
      hour: (0, _moment2.default)().format('HH:mm'),
      days: _this.days,
      color: 0,
      months: _this.months,
      events: _this.props.data.events || [],
      recurrenceOptions: null,
      recurrenceSelected: null,
      task: _this.props.data,
      eventId: 0,
      index: 0,
      validForm: null,
      file_columns: _this.props.data.file_columns,
      flag: 0,
      is_update_event: false,
      update_event: {},
      fileUploadResult: _this.props.data.fileUploadResult,
      fileStats: _this.props.data.fileStats,
      trackable_urls: _this.props.data.trackable_urls
    };

    _this.deleteSingleEvent = function (eventIndex, event) {
      var newEvents = _this.state.events;
      var selectedDates = _this.state.selectedDates;
      newEvents.splice(eventIndex, 1);
      selectedDates.splice(eventIndex, 1);
      _this.setState((0, _extends9.default)({}, _this.state, {
        events: newEvents,
        selectedDates: selectedDates,
        selectedDate: selectedDates[eventIndex - 1],
        is_update_event: false
      }));
    };
    return _this;
  }

  (0, _createClass3.default)(ScheduleWizard, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.getrecurrenceOptions();
      this.props.getAccountStatus().then(function (accountStatus) {
        _this2.setState({ accountStatus: accountStatus });
      });
    }
  }, {
    key: 'getrecurrenceOptions',
    value: function getrecurrenceOptions() {
      var _this3 = this;

      this.props.getSchedulerRecurrences().then(function (data) {
        var noReccurrent = { value: 'NO RECURRENT', label: 'Envío Único' };
        data.push(noReccurrent);
        _this3.setState({
          recurrenceOptions: data
        });
        if (_this3.state.trackable_urls) {
          _this3.setState({
            recurrenceSelected: noReccurrent,
            finishDate: null
          });
        }
        return data;
      });
    }
  }, {
    key: 'getTimeOptions',
    value: function getTimeOptions() {
      var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'H';

      var options = [];
      var accountStatus = this.state.accountStatus;
      var allowed_service_hour_start = accountStatus && accountStatus.csm && accountStatus.csm.allowed_service_hour_start;
      var allowed_service_hour_end = accountStatus && accountStatus.csm && accountStatus.csm.allowed_service_hour_end;
      var i = void 0;
      var thisHour = allowed_service_hour_start;
      var thisMinute = 0;
      var from = 0;
      var to = 0;

      var processingOffset = this.state.fileStats ? Math.max(this.state.fileStats.estimated_processing_min + 5, SCHEDULER_OFFSET) : SCHEDULER_OFFSET;

      var momentDate = (0, _moment2.default)(this.state.selectedDate, 'YYYY-MM-DD');
      var currentMoment = (0, _moment2.default)();

      if (currentMoment.diff(momentDate) > 0) {
        var offsetTime = currentMoment.add(processingOffset, 'minutes');
        var offsetHour = parseInt(offsetTime.format('H'));
        var offsetMinute = parseInt(offsetTime.format('m'));
        var isWithinServiceHours = offsetHour >= allowed_service_hour_start && offsetHour <= allowed_service_hour_end;

        if (isWithinServiceHours) {
          thisHour = offsetHour;
          thisMinute = offsetMinute;
        }
      }

      if (format === 'm') {
        if (this.state.selectedHour && parseInt(this.state.selectedHour) > parseInt(currentMoment.format('H'))) {
          from = 0;
          to = 59;
        } else {
          from = thisMinute;
          to = 59;
        }
      } else {
        from = thisHour;
        to = allowed_service_hour_end;
      }

      for (i = from; i <= to; i++) {
        var value = i;
        var label = '' + (i < 10 ? '0' + i : '' + i);
        var option = { value: value, label: label };
        options.push(option);
      }
      return options;
    }
  }, {
    key: 'getYearOptions',
    value: function getYearOptions() {
      var options = [];
      var i = (0, _moment2.default)().year();
      var imax = i + 10;
      for (i; i <= imax; i++) {
        var value = i;
        var label = '' + i;
        var option = { value: value, label: label };
        options.push(option);
      }
      return options;
    }
  }, {
    key: 'getDayOptions',
    value: function getDayOptions(year, month) {
      if (month <= 8) {
        var _lastDay = (0, _moment2.default)(year + '-0' + (month + 1)).endOf('month').format('DD');
        var _options = [];
        var _i = void 0;
        for (_i = 1; _i <= _lastDay; _i++) {
          var value = _i;
          var label = '' + (_i < 10 ? '0' + _i : '' + _i);
          var option = { value: value, label: label };
          _options.push(option);
        }
        return _options;
      }
      var lastDay = (0, _moment2.default)(year + '-' + (month + 1)).endOf('month').format('DD');
      var options = [];
      var i = void 0;
      for (i = 1; i <= lastDay; i++) {
        var _value2 = i;
        var _label = '' + (i < 10 ? '0' + i : '' + i);
        var _option = { value: _value2, label: _label };
        options.push(_option);
      }
      return options;
    }
  }, {
    key: 'generateLabels',
    value: function generateLabels(data) {
      var options = [];
      if (data) {
        var i = void 0;
        for (i = 0; i < data.length; i++) {
          var value = data[i];
          var label = (0, _translations2.default)(data[i]);
          var option = { value: value, label: label };
          options.push(option);
        }
      }
      return options;
    }
  }, {
    key: 'getIndex',
    value: function getIndex(index) {
      if (index < 10 && index >= 0) {
        return index;
      }
      var i = index % 10;
      return i;
    }
  }, {
    key: 'handleDateChange',
    value: function handleDateChange(whichDate, date) {
      var dates = this.state.selectedDates;
      var index = dates.indexOf(date.format('YYYY-MM-DD'));
      var len = dates.length;
      var i = index === -1 ? this.getIndex(len) : this.getIndex(index);

      this.state.color = i, this.state.selectedDate = date.format('YYYY-MM-DD'), this.state.finishMonth = date.format('M') - 1, this.state.finishDay = date.format('D'), this.state.finishYear = date.format('YYYY'), this.state.selectedDate = date.format('YYYY-MM-DD');
      this.forceUpdate();
    }
  }, {
    key: 'handleTabChange',
    value: function handleTabChange(tabSelected, event) {
      event.preventDefault();
      event.stopPropagation();
      this.setState((0, _extends9.default)({}, this.state, {
        tabSelected: tabSelected
      }));
    }
  }, {
    key: 'handleChange',
    value: function handleChange(which, event) {
      this.setState((0, _extends9.default)({}, this.state, (0, _defineProperty3.default)({}, which, event.target.value)));
    }
  }, {
    key: 'changeRecurrence',
    value: function changeRecurrence(which, event) {
      var finishDateChange = this.state.finishDate;
      if (event.value === "NO RECURRENT") {
        finishDateChange = null;
      }
      if (event.value === "MONTHLY") {
        this.setState({
          isMonthly: true
        });
      }
      this.setState({
        recurrenceSelected: event,
        finishDate: finishDateChange
      });
    }
  }, {
    key: 'handleHourChange',
    value: function handleHourChange(which, value) {
      var _extends3;

      this.setState((0, _extends9.default)({}, this.state, (_extends3 = {}, (0, _defineProperty3.default)(_extends3, which, value), (0, _defineProperty3.default)(_extends3, 'selectedHour', value.value), (0, _defineProperty3.default)(_extends3, 'selectedMinute', null), (0, _defineProperty3.default)(_extends3, 'minute', null), _extends3)));
    }
  }, {
    key: 'handleMinuteChange',
    value: function handleMinuteChange(which, value) {
      var _extends4;

      this.setState((0, _extends9.default)({}, this.state, (_extends4 = {}, (0, _defineProperty3.default)(_extends4, which, value), (0, _defineProperty3.default)(_extends4, 'selectedMinute', value.value), _extends4)));
    }
  }, {
    key: 'handleWeekDays',
    value: function handleWeekDays(which, value) {
      this.setState((0, _extends9.default)({}, this.state, (0, _defineProperty3.default)({}, which, value)));
    }
  }, {
    key: 'handleDone',
    value: function handleDone() {
      var data = this.state.task;
      data.events = this.state.events.map(function (evt) {
        return evt;
      });
      if (this.state.messageInFile) {
        data.messageInFile = this.state.messageInFile;
      }
      data.fileUploadResult = this.state.fileUploadResult;
      data.fileStats = this.state.fileStats;
      data.file_columns = this.state.file_columns;
      data.channel_type = 'SMS';
      this.props.handleComponentChange(2, data);
    }
  }, {
    key: 'handleAddEvent',
    value: function handleAddEvent(which, value) {
      this.state.flag = 1;
      var dates = this.state.selectedDates;
      var date = this.state.selectedDate;
      var event_data = {};
      var validForm = false;

      // validar hora no vacia y recurrencia no vacia
      if (this.state.recurrenceSelected !== null && this.state.selectedHour !== null && this.state.selectedMinute !== null) {
        //creamos la data del evento
        event_data = {
          status: 'ACTIVE',
          execution_date: this.state.selectedDate,
          execution_hour: this.state.selectedHour,
          execution_minute: this.state.selectedMinute,
          recurrence: {
            term: this.state.recurrenceSelected.value,
            label: this.state.recurrenceSelected.label
          }

          // agregamos recurrencia unica
        };if (this.state.recurrenceSelected.value === 'NO RECURRENT') {
          //event_data.end_date = this.state.selectedDate
          validForm = true;
        } else {
          // validamos si recurrencia es semanal
          if (this.state.recurrenceSelected.value === 'WEEKLY') {
            event_data.recurrence.value = this.state.selectedWeekDays.map(function (item) {
              return item.value;
            });
          }

          if (this.state.recurrenceSelected.value !== 'NO RECURRENT' && this.state.finishDate !== null) {
            if (this.state.finishDate === 0) {
              validForm = true;
            } else {
              if (this.state.finishDate == 1) {
                if (this.state.finishYear !== null && this.state.finishMonth !== null && this.state.finishDay !== null) {
                  event_data.start_date = this.state.selectedDate;
                  var end_date = (0, _moment2.default)([this.state.finishYear, this.state.finishMonth, this.state.finishDay]).toISOString();
                  event_data.end_date = end_date;
                  validForm = true;
                }
              }
            }
          }
        }
      }

      if (validForm) {

        var events = this.state.events;

        if (!this.state.is_update_event || this.state.events.length === 0) {
          event_data.tmp_uid = this.UUID();
          events.push(event_data);
        } else {
          if (events.indexOf(this.state.update_event) != -1) {
            event_data.tmp_uid = this.state.update_event.tmp_uid;
            events[events.indexOf(this.state.update_event)] = event_data;
          } else {
            throw "event evaluated to update not exists";
          }
        }
        dates.push(date);
        this.state.flag = 0;
        var recurrenceSelected = null;
        if (this.state.fileStats && this.state.trackable_urls) recurrenceSelected = { value: 'NO RECURRENT', label: 'Envío Único' };

        this.setState({
          finishDate: null,
          finishMonth: null,
          finishDay: null,
          finishYear: null,
          selectedHour: null,
          selectedMinute: null,
          hour: null,
          minute: null,
          recurrenceSelected: recurrenceSelected,
          events: events,
          tabSelected: 3,
          update_event: {},
          is_update_event: false
        });
      } else {
        throw "invalid form value";
      }
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      if (this.state.events.length !== 0) {
        this.setState((0, _extends9.default)({}, this.state, {
          finishDate: null,
          finishMonth: null,
          finishDay: null,
          finishYear: null,
          selectedHour: null,
          selectedMinute: null,
          hour: null,
          minute: null,
          recurrenceSelected: null,
          tabSelected: 3,
          is_update_event: false,
          update_event: {}
        }));
      }
    }
  }, {
    key: 'getColor',
    value: function getColor() {
      var color = this.state.colors[this.state.color];
      return color;
    }
  }, {
    key: 'deleteEvents',
    value: function deleteEvents() {
      this.setState((0, _extends9.default)({}, this.state, {
        events: [],
        selectedDates: [],
        tabSelected: 2
      }));
    }
  }, {
    key: 'showFinishDate',
    value: function showFinishDate() {
      var result = false;
      if (this.state.recurrenceSelected) {
        if (this.state.recurrenceSelected.value !== 'NO RECURRENT') {
          result = true;
        }
      }

      return result;
    }
  }, {
    key: 'showRecurrenceDays',
    value: function showRecurrenceDays() {
      var result = false;
      if (this.state.recurrenceSelected) {
        if (this.state.recurrenceSelected.value === 'WEEKLY') {
          result = true;
        }
      }
      return result;
    }
  }, {
    key: 'finishDateChange',
    value: function finishDateChange(which, event) {
      this.setState((0, _extends9.default)({}, this.state, (0, _defineProperty3.default)({}, which, event.value)));
    }
  }, {
    key: 'setFinishDate',
    value: function setFinishDate(which, event) {
      this.setState((0, _extends9.default)({}, this.state, (0, _defineProperty3.default)({}, which, event.value)));
    }
  }, {
    key: 'generateIndexMonthsValue',
    value: function generateIndexMonthsValue(dataArray) {
      var result = dataArray.map(function (label, lastValue) {
        var value = lastValue;
        return { value: value, label: label };
      });
      return result;
    }
  }, {
    key: 'validateHour',
    value: function validateHour() {
      var result = false;
      if (this.state.selectedHour !== null) {
        result = true;
      }
      return result;
    }
  }, {
    key: 'validateMinute',
    value: function validateMinute() {
      var result = false;
      if (this.state.selectedMinute !== null) {
        result = true;
      }
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var columns = [{
        Header: (0, _translations2.default)('SUMMARY DATES TEXT'),
        accessor: 'execution_date',
        minWidth: 100,
        Cell: function Cell(props) {
          return _react2.default.createElement(
            'div',
            null,
            props.row.execution_date ? props.row.execution_date : props.row.start_date
          );
        }
      }, {
        Header: (0, _translations2.default)('HOUR'),
        accessor: 'execution_hour',
        maxWidth: 40,
        Cell: function Cell(props) {
          return _react2.default.createElement(
            'div',
            null,
            props.row.execution_hour,
            ':',
            props.row._original.execution_minute < 10 ? '0' + props.row._original.execution_minute : props.row._original.execution_minute
          );
        }
      }, {
        Header: (0, _translations2.default)('RECURRENCE'),
        accessor: 'recurrence.label',
        maxWidth: 100
      }, {
        Header: '',
        maxWidth: 50,
        Cell: function Cell(props) {
          return _react2.default.createElement(
            'div',
            { className: _Wizard2.default.bin, onClick: _this4.deleteSingleEvent.bind(_this4, props.index) },
            _react2.default.createElement(md.delete, { size: 18, color: '#ababab' })
          );
        }
      }];

      var options = [{ value: 1, label: 'Con fecha de finalización' }, { value: 0, label: 'Sin fecha de finalización' }];
      var hourOptions = this.getTimeOptions('H');
      var minuteOptions = this.getTimeOptions('m');
      var weekDays = this.state.days;
      var recurrenceSelected = this.state.recurrenceSelected;
      var monthOptions = this.generateIndexMonthsValue(this.state.months);
      var dayOptions = this.getDayOptions(this.state.finishYear, this.state.finishMonth);
      var yearOptions = this.getYearOptions();
      var eventsLength = this.state.events.length;
      var formFeedback = { boxShadow: '0 0 15px red', height: '36px' };
      var padding = { padding: '4px' };
      var finishMonth = this.state.finishMonth;
      var classesTheme = (0, _themeEnabled.getThemeEnabledStyle)(_Wizard2.default);
      var isTrackableUrls = this.state.trackable_urls;
      return _react2.default.createElement(
        'div',
        { className: classesTheme },
        _react2.default.createElement(
          'div',
          { className: _Wizard2.default.main },
          _react2.default.createElement(
            'div',
            { className: _Wizard2.default.calendar },
            _react2.default.createElement(
              'h1',
              null,
              ' ',
              (0, _translations2.default)('SELECT DATE'),
              ' '
            ),
            _react2.default.createElement(
              'a',
              { href: '#dateInfo', onClick: this.handleTabChange.bind(this, 2) },
              _react2.default.createElement(_components.MultiDatepicker, {
                onChange: this.handleDateChange.bind(this, 'startDate'),
                selectedDates: this.state.selectedDates,
                timeFormat: false,
                colors: this.state.colors,
                currentDate: this.state.selectedDate,
                compact: true
              })
            ),
            _react2.default.createElement(
              'div',
              { className: _Wizard2.default.container },
              _react2.default.createElement(
                'div',
                { className: _Wizard2.default.table },
                _react2.default.createElement(_components.Table, {
                  pageSize: 5,
                  data: this.state.events,
                  columns: columns,
                  isLoading: false,
                  onClick: this.begin_update
                })
              ),
              eventsLength > 0 ? _react2.default.createElement(
                'div',
                { onClick: this.deleteEvents, className: _Wizard2.default.delete },
                _react2.default.createElement(
                  'h1',
                  null,
                  ' ',
                  (0, _translations2.default)('DELETE ALL SCHEDULED MESSAGES'),
                  ' '
                ),
                _react2.default.createElement(md.delete, { size: 18, color: '#ababab' })
              ) : _react2.default.createElement('div', null)
            )
          ),
          _react2.default.createElement(
            'div',
            { id: 'dateSelect', style: { display: this.state.tabSelected === 1 ? 'flex' : 'none' }, className: _Wizard2.default.aside },
            _react2.default.createElement(
              'div',
              { className: _Wizard2.default.container },
              _react2.default.createElement(
                'p',
                null,
                ' ',
                (0, _translations2.default)('SELECT DATE TEXT'),
                ' '
              )
            ),
            _react2.default.createElement('img', { className: _Wizard2.default.image, src: (0, _useBasename2.default)('/static/messages.svg') })
          ),
          _react2.default.createElement(
            'div',
            (0, _defineProperty3.default)({ id: 'dateInfo', className: _Wizard2.default.dateInfo, style: { display: this.state.tabSelected === 2 ? 'flex' : 'none' } }, 'className', _Wizard2.default.aside),
            _react2.default.createElement(
              'div',
              { className: _Wizard2.default.container },
              _react2.default.createElement(
                'h1',
                null,
                ' ',
                (0, _moment2.default)(this.state.selectedDate).locale('es').format('dddd, D MMMM YYYY'),
                ' '
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _Wizard2.default.container },
              _react2.default.createElement(
                'h2',
                null,
                ' ',
                (0, _translations2.default)('SENDING HOUR TEXT'),
                ' '
              ),
              _react2.default.createElement(
                'div',
                { className: _Wizard2.default.dateContainer },
                _react2.default.createElement(
                  'div',
                  { className: _Wizard2.default.selectDate, style: this.state.selectedHour === null && !this.state.flag ? formFeedback : padding },
                  _react2.default.createElement(_reactSelect2.default, {
                    className: _Wizard2.default.timeSelector,
                    ref: 'selectedHour',
                    closeMenuOnSelect: false,
                    defaultValue: hourOptions[0],
                    options: hourOptions,
                    placeholder: (0, _translations2.default)('SELECT HOUR'),
                    value: this.state.hour,
                    onChange: this.handleHourChange.bind(this, 'hour')
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Wizard2.default.selectDate, style: this.state.selectedMinute === null && !this.state.flag ? formFeedback : padding },
                  _react2.default.createElement(_reactSelect2.default, {
                    className: _Wizard2.default.minuteSelector,
                    ref: 'selectedMinute',
                    closeMenuOnSelect: false,
                    defaultValue: minuteOptions[0],
                    options: minuteOptions,
                    placeholder: (0, _translations2.default)('SELECT MINUTE'),
                    value: this.state.minute,
                    onChange: this.handleMinuteChange.bind(this, 'minute')
                  })
                )
              )
            ),
            !isTrackableUrls && _react2.default.createElement(
              'div',
              { className: _Wizard2.default.container },
              _react2.default.createElement(
                'h2',
                null,
                ' ',
                (0, _translations2.default)('RECURRENCE TEXT'),
                ' '
              ),
              _react2.default.createElement(
                'div',
                { className: _Wizard2.default.select, style: !this.state.recurrenceSelected && !this.state.flag ? formFeedback : padding },
                _react2.default.createElement(_reactSelect2.default, {
                  ref: 'selectedrecurrence',
                  multi: false,
                  closeMenuOnSelect: false
                  // defaultValue={{value: "NO RECURRENT"}}
                  , options: this.state.recurrenceOptions,
                  value: this.state.recurrenceSelected,
                  placeholder: (0, _translations2.default)('SELECT'),
                  onChange: this.changeRecurrence.bind(this, 'recurrence')
                })
              ),
              this.state.isMonthly && this.state.finishDay > 28 ? _react2.default.createElement(
                'h2',
                null,
                (0, _translations2.default)('MONTHLY REMINDER')
              ) : _react2.default.createElement(
                'div',
                null,
                ' '
              )
            ),
            this.showRecurrenceDays() ? _react2.default.createElement(
              'div',
              { className: _Wizard2.default.container },
              _react2.default.createElement(
                'h2',
                null,
                ' ',
                (0, _translations2.default)('RECURRENCE DAYS TEXT'),
                ' '
              ),
              _react2.default.createElement(
                'div',
                { className: _Wizard2.default.select, style: !this.state.selectedWeekDays && !this.state.flag ? formFeedback : padding },
                _react2.default.createElement(_reactSelect2.default, {
                  multi: this.props.multi,
                  closeMenuOnSelect: false,
                  defaultValue: 0,
                  options: weekDays,
                  value: this.state.selectedWeekDays,
                  placeholder: this.props.placeholder,
                  onChange: this.handleWeekDays.bind(this, 'selectedWeekDays')
                })
              )
            ) : null,
            this.state.recurrenceSelected && this.state.recurrenceSelected.value != "NO RECURRENT" ? _react2.default.createElement(
              'div',
              { className: _Wizard2.default.container },
              _react2.default.createElement(
                'h2',
                null,
                ' ',
                (0, _translations2.default)('FINISH DATE TEXT'),
                ' '
              ),
              _react2.default.createElement(
                'div',
                { className: _Wizard2.default.select, style: this.state.finishDate === null && !this.state.flag ? formFeedback : padding },
                _react2.default.createElement(_reactSelect2.default, {
                  multi: false,
                  closeMenuOnSelect: false
                  // defaultValue={recurrenceOptions[0]}
                  , options: options,
                  placeholder: (0, _translations2.default)('SELECT'),
                  value: this.state.finishDate,
                  onChange: this.finishDateChange.bind(this, 'finishDate')
                })
              ),
              this.state.finishDate === 1 ? _react2.default.createElement(
                'div',
                { className: _Wizard2.default.row },
                _react2.default.createElement(
                  'div',
                  { className: _Wizard2.default.year },
                  _react2.default.createElement(
                    'div',
                    { className: _Wizard2.default.select, style: !this.state.finishYear && !this.state.flag ? formFeedback : padding },
                    _react2.default.createElement(_reactSelect2.default, {
                      multi: false,
                      closeMenuOnSelect: false,
                      defaultValue: yearOptions[0],
                      className: _Wizard2.default.selector,
                      options: yearOptions,
                      placeholder: (0, _translations2.default)('SELECT'),
                      value: this.state.finishYear,
                      onChange: this.setFinishDate.bind(this, 'finishYear')
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Wizard2.default.month },
                  _react2.default.createElement(
                    'div',
                    { className: _Wizard2.default.select, style: !finishMonth && !this.state.flag ? formFeedback : padding },
                    _react2.default.createElement(_reactSelect2.default, {
                      multi: false,
                      closeMenuOnSelect: false
                      // defaultValue={monthOptions[0]}
                      , className: _Wizard2.default.selector,
                      options: monthOptions,
                      value: this.state.finishMonth,
                      placeholder: (0, _translations2.default)('SELECT')
                      // placeholder={this.props.placeholder}
                      , onChange: this.setFinishDate.bind(this, 'finishMonth')
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: _Wizard2.default.options },
                  _react2.default.createElement(
                    'div',
                    { className: _Wizard2.default.day },
                    _react2.default.createElement(
                      'div',
                      { className: _Wizard2.default.select, style: !this.state.finishDay && !this.state.flag ? formFeedback : padding },
                      _react2.default.createElement(_reactSelect2.default, {
                        multi: false,
                        closeMenuOnSelect: false,
                        defaultValue: dayOptions[0],
                        className: _Wizard2.default.selector,
                        options: dayOptions,
                        value: this.state.finishDay,
                        placeholder: (0, _translations2.default)('SELECT'),
                        onChange: this.setFinishDate.bind(this, 'finishDay')
                      })
                    )
                  )
                )
              ) : null
            ) : null,
            _react2.default.createElement(
              'div',
              { className: _Wizard2.default.formButtons },
              this.state.events != null && this.state.events.length > 0 ? _react2.default.createElement(
                'div',
                { className: _Wizard2.default.formButton },
                _react2.default.createElement(
                  'a',
                  {
                    disabled: this.state.events === [],
                    onClick: this.cancel
                  },
                  this.state.is_update_event ? (0, _translations2.default)('CANCEL EDIT EVENT') : (0, _translations2.default)('CANCEL EVENT')
                )
              ) : _react2.default.createElement(
                'div',
                null,
                ' '
              ),
              !this.state.is_update_event ? _react2.default.createElement(
                'div',
                { className: _Wizard2.default.formButton },
                _react2.default.createElement(
                  'a',
                  { onClick: this.handleAddEvent.bind(this, 3) },
                  (0, _translations2.default)('ADD EVENT')
                )
              ) : _react2.default.createElement('spam', null),
              this.state.is_update_event ? _react2.default.createElement(
                'div',
                { className: _Wizard2.default.formButton },
                _react2.default.createElement(
                  'a',
                  { onClick: this.handleAddEvent },
                  (0, _translations2.default)('SAVE EVENT')
                )
              ) : _react2.default.createElement('spam', null)
            )
          ),
          _react2.default.createElement(
            'div',
            { id: 'final', style: { display: this.state.tabSelected === 3 ? 'flex' : 'none' }, className: _Wizard2.default.aside },
            _react2.default.createElement(
              'div',
              { className: _Wizard2.default.container },
              _react2.default.createElement(
                'p',
                null,
                ' ',
                (0, _translations2.default)('SELECT DATE FINISH'),
                ' '
              )
            ),
            _react2.default.createElement('img', { className: _Wizard2.default.image2, src: (0, _useBasename2.default)('/static/messages2.svg') }),
            _react2.default.createElement(
              'div',
              { className: _Wizard2.default.container },
              _react2.default.createElement(
                'a',
                { onClick: this.handleDone },
                (0, _translations2.default)('DONE')
              )
            )
          )
        )
      );
    }
  }]);
  return ScheduleWizard;
}(_react2.default.Component), _class3.defaultProps = {
  multi: true,
  value: [],
  placeholder: 'Seleccione una o varias opciones'
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'getrecurrenceOptions', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getrecurrenceOptions'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleDateChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleDateChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleTabChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleTabChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'changeRecurrence', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'changeRecurrence'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleHourChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleHourChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleMinuteChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleMinuteChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleWeekDays', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleWeekDays'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleDone', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleDone'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleAddEvent', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'handleAddEvent'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cancel', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'cancel'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteEvents', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteEvents'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'finishDateChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'finishDateChange'), _class2.prototype)), _class2)) || _class);
exports.default = ScheduleWizard;
module.exports = exports['default'];